import styles from "../styles/Footer.module.css";

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.left}>
          <span className={styles.label}>Get in touch</span>
          <span className={styles.line} />
        </div>

        <a
          href="mailto:krzysztof.m.chabowski@gmail.com"
          className={styles.emailBtn}
        >
          Email Me
          <span className={styles.chev}>›</span>
        </a>

        <div className={styles.right}>
          <span className={styles.line} />
          <a
            href="https://www.linkedin.com/in/krzysztof-chabowski"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.iconBtn}
            aria-label="LinkedIn"
          >
            in
          </a>
        </div>
      </div>
    </footer>
  );
}
